import Reveal from "@/components/Reveal";
import { highlightServices, allServices } from "@/data/services";
import { ArrowUpRight } from "lucide-react";

export default function Servizi() {
    return (
        <section
            id="servizi"
            data-testid="section-servizi"
            className="relative bg-ink-900 py-28 lg:py-36"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
                <Reveal>
                    <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-20">
                        <div>
                            <p className="text-xs uppercase tracking-widest text-brass">
                                Servizi — 02
                            </p>
                            <h2
                                data-testid="servizi-title"
                                className="mt-6 font-serif font-light text-cream text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-2xl"
                            >
                                Cosa facciamo
                                <span className="italic text-brass"> bene</span>
                                .
                            </h2>
                        </div>
                        <p className="text-base text-cream/65 leading-relaxed max-w-md">
                            Ci occupiamo di ogni fase del pavimento in legno —
                            dalla scelta del materiale alla manutenzione —
                            per offrire un risultato coerente e duraturo.
                        </p>
                    </div>
                </Reveal>

                {/* 3-column highlight */}
                <div
                    data-testid="servizi-highlight-grid"
                    className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/5 border border-white/5"
                >
                    {highlightServices.map(({ id, title, description, Icon }, i) => (
                        <Reveal key={id} delay={i * 100}>
                            <div
                                data-testid={`servizio-highlight-${id}`}
                                className="group relative bg-ink-900 hover:bg-ink-800 transition-colors duration-700 p-10 lg:p-12 h-full flex flex-col"
                            >
                                <Icon
                                    size={32}
                                    strokeWidth={1}
                                    className="text-brass mb-10"
                                />
                                <h3 className="font-serif text-2xl lg:text-3xl text-cream font-light">
                                    {title}
                                </h3>
                                <p className="mt-5 text-sm lg:text-base text-cream/65 leading-relaxed">
                                    {description}
                                </p>
                                <span className="mt-10 inline-flex items-center gap-2 text-xs uppercase tracking-widest text-brass/80 group-hover:text-brass transition-colors">
                                    Scopri di più
                                    <ArrowUpRight
                                        size={14}
                                        className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
                                    />
                                </span>
                            </div>
                        </Reveal>
                    ))}
                </div>

                {/* Tutti i servizi */}
                <div className="mt-28">
                    <Reveal>
                        <div className="flex items-end justify-between mb-12">
                            <h3
                                data-testid="tutti-servizi-title"
                                className="font-serif text-3xl lg:text-4xl text-cream font-light"
                            >
                                Tutti i servizi
                            </h3>
                            <span className="hidden md:block text-xs uppercase tracking-widest text-cream/40">
                                / 08
                            </span>
                        </div>
                    </Reveal>

                    <div
                        data-testid="tutti-servizi-grid"
                        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5"
                    >
                        {allServices.map(({ id, title, description, Icon }, i) => (
                            <Reveal key={id} delay={i * 60}>
                                <div
                                    data-testid={`servizio-${id}`}
                                    className="group bg-ink-900 hover:bg-ink-800 transition-all duration-700 p-8 h-full flex flex-col border-b border-transparent hover:border-brass"
                                >
                                    <Icon
                                        size={26}
                                        strokeWidth={1}
                                        className="text-brass mb-6 transition-transform duration-700 group-hover:-translate-y-1"
                                    />
                                    <h4 className="font-serif text-xl text-cream font-normal leading-snug">
                                        {title}
                                    </h4>
                                    <p className="mt-4 text-sm text-cream/60 leading-relaxed">
                                        {description}
                                    </p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
